import { IValidationResult, ValidationHandler } from './validator';

export const createResults = async <T>(value: T, chain: ValidationHandler<T>[]) => {
  return chain.reduce(async (previousResultsPromise, validate) => {
    // If previous in chain has invalid results don't continue;
    const previousResults = await previousResultsPromise;
    if (previousResults.some((x) => !x.valid)) {
      return previousResults;
    }

    const result = await validate(value);

    return [...previousResults, ...result];
  }, Promise.resolve<IValidationResult[]>([]));
};
